import React, {useEffect, useState} from "react";
import "./style.scss";

import {useSelector} from "react-redux";
import FinancialPerformance from "../../../components/AccountMetrics/FinancialPerformance";
import Statistic from "../../../components/AccountMetrics/Statistic";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import Goals from "../../../components/AccountMetrics/GoalsOverview/Goals";

function ProgramObjectives() {
  const accountsData = useSelector((state) => state?.account?.accountMetrics);
  const [Ametrics, setAmetrics] = useState([]);
  const [metrics, setMetrics] = useState([]);
  const [programObjective, setProgramObjective] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");
  const [errorModalOpen, setErrorModalOpen] = useState(accountsData.error);

  useEffect(() => {
    setAmetrics(accountsData.data?.account_advance_metrics);
    setMetrics(accountsData.data?.account_metrics);
    setProgramObjective(accountsData.data?.program_objectives);
    setLastUpdated(accountsData.lastUpdated);
  }, [accountsData]);
  useEffect(() => {
    setErrorModalOpen(accountsData.error);
  }, [accountsData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const startingBalance = accountsData?.data?.starting_balance || 0;

  const formattedBalance = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(startingBalance);
  return (
    <>
      <div className="programobjectives-container">
        {errorModalOpen && (
          <ErrorModal
            desc={accountsData.message}
            setModalOpen={setErrorModalOpen}
            btnText="Cancel"
          />
        )}
        <div className="firstRowContent">
          <Statistic
            value={Ametrics}
            value2={metrics}
            challenge={accountsData?.data?.challenge}
            lastUpdated={lastUpdated}
          />
        </div>
        <div className="secondRowContent">{!accountsData.error && !accountsData.loading && <FinancialPerformance />}</div>
        <div className="thirdRowContent">
          <Goals
            programObjective={programObjective}
            data={accountsData?.data}
          />
        </div>
      </div>
    </>
  );
}

export default ProgramObjectives;
